export class BookingFilterBuilder {
    constructor() {
        //
    }
}
